import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const StyledEmptyStateContainer = styled.div`
  margin: 8px 0px;
  padding: 56px;
  justify-items: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.subtle};
  border: 1px solid
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
`;

export const NotesContainer = styled.div`
  grid-column: span 2;
`;

export const DetailLabel = styled.p`
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  margin: 0px;
`;
export const LinkedCaseItemContainer = styled.div`
  margin: 8px 0px;
  padding: 20px;
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.turquoise.T100
      : props.theme.atlas.semantic.color.action.secondary.hoverFill};
  border: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T400
        : props.theme.atlas.semantic.color.action.primary.hover};
  border-radius: 6px;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
`;

export const StyledTableRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 24px;
`;

export const StyledRowContent = styled.div`
  flex: 1;
  flex-direction: column;
`;

export const FormContainer = styled.div`
  margin-bottom: 16px;
`;

export const TableContainer = styled.div`
  position: relative;
  margin: 8px 0px;
`;

export const LoaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 10;
  border-radius: 6px;
`;
